import styled from 'styled-components';

export const MiniCompanyMisssionStyled = styled.div`
  font-family: noto_sans_thai_medium, noto_sans_regular;
  font-size: ${({ theme }) => theme.FONT.SIZE.S14};
  .mini_company_top_current {
    display: flex;
    justify-content: space-between;
    .mini_top_left_current {
      display: flex;
      margin-left: 10px;
      .show_icon {
        margin-right: 16px;
        display: flex;
      }
    }
  }
  .mini_company_mid_current {
    margin-top: 16px;
    margin-left: 10px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S28};
    font-family: noto_sans_thai_bold, noto_sans_bold;
  }
  .mini_company_bottom_current {
    margin-top: 24px;
    display: flex;
    font-size: ${({ theme }) => theme.FONT.SIZE.S15};
    align-items: center;
    .show_icon_bottom {
      margin-right: 13px;
      display: flex;
    }
    .date_detail {
      color: ${({ theme }) => theme.COLORS.GRAY_4};
    }
  }
`;
